import {
    getOptionsForFeature,
    LinkedInBindingDismissedOptions,
    OwsOptionsFeatureType,
} from 'owa-outlook-service-options';

export default function isLinkedInBindingButtonDismissed(): boolean {
    let linkedInBindingDismissed = getOptionsForFeature<LinkedInBindingDismissedOptions>(
        OwsOptionsFeatureType.LinkedInBindingDismissed
    );

    return linkedInBindingDismissed.linkedInBindingDismissedInPeoplePicker;
}
